export default function Sidebar({
	recentChats,
	selectedChat,
	selectChat,
	search,
	setSearch,
	loading,
}) {
	const filteredChats = recentChats.filter((chat) =>
		(chat.displayName || "").toLowerCase().includes(search.toLowerCase()),
	);

	const logo = "/VRSamadhanSahayak.png";
	const getInitial = (chat) => {
		let source = chat.displayName || chat.name || "";

		if (!source) return "?";

		source = source.replace(/\s+/g, "");

		source = source.replace(/^\+?\d{1,2}/, "");

		if (/^\d+$/.test(source)) {
			return source.charAt(0);
		}

		return source.charAt(0).toUpperCase();
	};
	const getAvatarColor = (text) => {
		const colors = [
			"bg-red-200 text-red-700",
			"bg-green-200 text-green-700",
			"bg-blue-200 text-blue-700",
			"bg-purple-200 text-purple-700",
			"bg-yellow-200 text-yellow-700",
			"bg-pink-200 text-pink-700",
		];

		let sum = 0;
		for (let i = 0; i < text.length; i++) {
			sum += text.charCodeAt(i);
		}

		return colors[sum % colors.length];
	};
	return (
		<div className="h-full w-[400px] min-h-0 bg-white flex flex-col border-r">
			<div className="flex items-center gap-3 p-4">
				<img src={logo} alt="Logo" className="h-8 w-8 object-contain" />
				<div className="h-6 w-px bg-gray-300"></div>
				<div className="font-semibold text-[#0b5cff] text-lg">
					VRSamadhan Sahayak
				</div>
			</div>

			<div className="p-3">
				<input
					value={search}
					onChange={(e) => setSearch(e.target.value)}
					placeholder="Search chat"
					className="w-full px-4 py-2 bg-gray-100 rounded-full"
				/>
			</div>

			<div className="theme-scrollbar min-h-0 flex-1 overflow-y-auto">
				{loading ? (
					<div className="p-3 space-y-3">
						{[...Array(7)].map((_, index) => (
							<div
								key={index}
								className="flex items-center gap-3 rounded-2xl border border-gray-100 px-3 py-3"
							>
								<div className="h-10 w-10 animate-pulse rounded-full bg-gray-200"></div>

								<div className="min-w-0 flex-1">
									<div className="mb-2 flex items-center justify-between gap-3">
										<div className="h-3 w-28 animate-pulse rounded-full bg-gray-200"></div>
										<div className="h-3 w-10 animate-pulse rounded-full bg-gray-100"></div>
									</div>
									<div className="h-3 w-full animate-pulse rounded-full bg-gray-100"></div>
								</div>
							</div>
						))}
					</div>
				) : filteredChats.length === 0 ? (
					<div className="px-4 py-10 text-center text-sm text-gray-400">
						No chats found
					</div>
				) : (
					filteredChats.map((chat) => (
						<div
							key={chat.id}
							onClick={() => selectChat(chat)}
							className={`p-3 flex gap-3 cursor-pointer border-b border-gray-200 ${
								selectedChat?.id === chat.id
									? "bg-[#e7f0ff]"
									: "hover:bg-gray-100"
							}`}
						>
							<div
								className={`h-10 w-10 rounded-full flex items-center justify-center font-bold ${getAvatarColor(
									chat.name,
								)}`}
							>
								{getInitial(chat)}
							</div>

							<div className="flex-1 min-w-0">
								<div className="flex justify-between items-center">
									<div
										className={`font-medium truncate ${
											chat.unread ? "font-bold" : ""
										}`}
									>
										{chat.displayName}
									</div>

									<div className="flex flex-col items-end gap-1">
										<div className="text-xs text-gray-500">{chat.time}</div>

										{chat.unread > 0 && (
											<div className="bg-[#0b5cff] text-white text-[10px] px-2 py-[2px] rounded-full">
												{chat.unread}
											</div>
										)}
									</div>
								</div>

								<div className="text-sm text-gray-500 truncate">
									{chat.lastMessage}
								</div>
							</div>
						</div>
					))
				)}
			</div>
		</div>
	);
}
